import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW2700Component } from './kymw2700.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { CheckAllPageService } from './api-services/check-all-page.service';
import { CheckBaseKomaPublishingService } from './api-services/check-base-koma-publishing.service';
import { CopyBasePageService } from './api-services/copy-base-page.service';
import { GetCatalogPageProgressService } from './api-services/get-catalog-page-progress.service';
import { GetCatalogPhaseInfoService } from './api-services/get-catalog-phase-info.service';
import { InitFixationPhaseComboService } from './api-services/init-fixation-phase-combo.service';
import { PhaseFixationService } from './api-services/phase-fixation.service';
import { OutputPagenationListService } from '../../kymw25/kymw2500/api-services/output-pagenation-list.service';

/**
 * 基版コピー・フェーズ管理画面 モジュール設定クラス
 *
 * @export KYMW2700Module
 * @class KYMW2700Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW2700Component,
  ],
  providers: [
    OutputPagenationListService,
    CheckAllPageService,
    CheckBaseKomaPublishingService,
    CopyBasePageService,
    GetCatalogPageProgressService,
    GetCatalogPhaseInfoService,
    InitFixationPhaseComboService,
    PhaseFixationService,
  ],
})
export class KYMW2700Module {
}
